import React from 'react';
import {Route, Routes} from "react-router-dom";
import {publicRoutes} from "../routes";
import NotFound from "../pages/NotFound";

const AppRouter = () => {
    return (
        <Routes>
            {publicRoutes.map(({path, component}) =>
                <Route key={path} path={path} element={component}/>
            )}
            {<Route path="*" element={<NotFound />}/>}
        </Routes>
    );
};

export default AppRouter;